import {
  GET_TERMS_ACCEPTANCE_LOGS
} from '../reducers/termsAcceptanceLogsReducer'
import type { ReduxAxiosAction } from './common'

export const getTermsAcceptanceLogs = (pageNumber: number = 1, pageSize: number = 50): ReduxAxiosAction => {
  return {
    type: GET_TERMS_ACCEPTANCE_LOGS,
    payload: {
      request: {
        mode: 'no-cors',
        url: `dashboard/terms-acceptance-logs?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        method: 'GET'
      }
    }
  }
}
